import { ImageElement } from '@/components/Elements/Image';

import type { IImageElement } from 'client-types/';

interface Props {
    items: IImageElement[];
}

const InlinedImageList = ({ items }: Props) => (
    <div
        className={
            items.length > 1
                ? 'grid grid-cols-2 gap-2 max-w-[400px]'
                : 'max-w-[200px]'
        }
    >
        {items.map((image, i) => (
            <div
                key={i}
                className="w-full h-[150px] overflow-hidden rounded-md"
            >
                <ImageElement element={image} />
            </div>
        ))}
    </div>
);

export { InlinedImageList };
